<template>
  <div class="card">
    <div class="card-body p-0">
      <cardHead 
      :title="'Schema'"></cardHead>
      <dataTable :name="'Currencies'" :data="data" :columnDefs="columnDefs" :rowGroupPanelShow="true"></dataTable>
    </div>
  </div>
</template>

<script>
import 'ag-grid-enterprise';
export default {
  name: 'schema',
  data(){
    return { 
      columnDefs: [
        { hide: true, rowGroup: true, enableRowGroup: true, headerName: "table", filter: 'agTextColumnFilter', field: "table", flex: 1, sortable:true},
        { headerName: "Name", filter: 'agTextColumnFilter', field: "Name", flex: 1, sortable:true},
        { headerName: "Type", field: "Type", flex: 1},
        { headerName: "Length", field: "Length", flex: 1},
        { headerName: "IsNullable", field: "IsNullable", flex: 1}
      ],
      data:null,
    }
  },
  created(){
    if(localStorage.getItem("agGrid")!=undefined){
      this.columnDefs=JSON.parse(localStorage.getItem("agGrid"));
    }
      this.$appAxiosAdmin.get(`Schema`).then(response => {
      this.data=[];
      response.data.forEach(table => {
        table.Columns.forEach(column => {
          this.data.push({
            ...column,
            table:table.Schema+"."+table.Name
          });
        });
      });
    });
  },
  watch:{
  }
}
</script>
